import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  activeFormatter,
  showConfirmDialog,
  formatDate,
  lockedFormatter,
  showDeleteDialog,
  checkPermision,
  formatQuantity,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import LoadingFetchData from "../../utility/LoadingFetchData";
import SVG from "react-inlinesvg";
import { Button, Col, Row } from "react-bootstrap";
import { editParty, removeInbound } from "./inboundSlice";

export const OverviewTable = ({
  data,
  page,
  sizePerPage,
  sortField,
  sortOrder,
  onTableChange,
  totalSize,
  loading,
  handleSearch,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);

  const handleDelete = async (e, row) => {
    const params = [{ inbound_id: `${row.inbound_id}` }];
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeInbound({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
          >
            <div
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
              onClick={() => {
                history.push(`/inbound/edit/${row.inbound_id}`);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
              </span>
            </div>
          </OverlayTrigger>
        </div>
      </>
    );
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
    },
    {
      text: "Job Number",
      dataField: "inbound_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "200px" },

    },
    {
      text: "Client",
      dataField: "client_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "200px" },

    },
    {
      text: "Shipper",
      dataField: "shipper_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "200px" },

    },

    {
      text: "Job Date",
      dataField: "job_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDate,
      style: { minWidth: "200px" },

    },
    {
      text: "ETD",
      dataField: "estimated_delivery",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDate,
      style: { minWidth: "200px" },

    },
    {
      text: "ETA",
      dataField: "estimated_arrive",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDate,
      style: { minWidth: "200px" },

    },
    {
      text: "Total VIN",
      dataField: "total_vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Total Model",
      dataField: "total_model",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatQuantity,
      align: "right",
      style: { minWidth: "150px" },
    },
    {
      text: "Status",
      dataField: "inbound_status_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      style: { minWidth: "200px" },
      headerAlign: "center",
      align: "center",
    },
  ];

  const options = {
    page: page < 0 ? 1 : page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-4"
        bootstrap4
        
        keyField="inbound_id"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        sort={{ dataField: sortField, order: sortOrder }}
        hover
        striped
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
      {/* Footer */}
    </>
  );
};
